/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RequestScope = {
    Client: 'Client',
    ClientInContext: 'ClientInContext'
} as const;
export type RequestScope = typeof RequestScope[keyof typeof RequestScope];


export function RequestScopeFromJSON(json: any): RequestScope {
    return RequestScopeFromJSONTyped(json, false);
}

export function RequestScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestScope {
    return json as RequestScope;
}

export function RequestScopeToJSON(value?: RequestScope | null): any {
    return value as any;
}

